// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ResetZoom = function ResetZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.554 8.478a5.077 5.077 0 1 0-10.155 0 5.077 5.077 0 0 0 10.154 0m-.981 5.176A6.6 6.6 0 0 1 1.875 8.478a6.6 6.6 0 0 1 6.6-6.601 6.6 6.6 0 0 1 5.177 10.698l4.25 4.25a.761.761 0 0 1-1.076 1.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.85 8.587a.75.75 0 0 1 .75-.75h3.859a.75.75 0 0 1 0 1.5h-3.86a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  }));
};
